import React, { useState, useEffect, useRef } from 'react';
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Footer from '../layout/Footer';
import './Navbar.css';

const NAV_LINKS = [
  { to: '/home',      label: 'Home' },
  { to: '/about',     label: 'About' },
  { to: '/s',         label: 'Explore' },
  { to: '/blog',      label: 'Blog' },
  { to: '/project-5', label: 'Project-5' },
];

const Navbar = () => {
  const { isAuthenticated } = useSelector((state) => state.user);
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const drawerRef = useRef(null);
  const location = useLocation();

  useEffect(() => { setOpen(false); }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open]);

  return (
    <>
      <nav className={`dmyor-nav${scrolled ? ' scrolled' : ''}${open ? ' menu-open' : ''}`}>
        <div className="dnav-inner">

          {/* Logo */}
          <Link to="/home" className="dnav-logo">dmyor</Link>

          {/* Desktop links */}
          <ul className="dnav-links">
            {NAV_LINKS.map(({ to, label }) => (
              <li key={to}>
                <NavLink
                  to={to}
                  className={({ isActive }) => `dnav-link${isActive ? ' active' : ''}`}
                >
                  {label}
                </NavLink>
              </li>
            ))}
          </ul>

          {/* Desktop auth */}
          <div className="dnav-auth">
            {isAuthenticated ? (
              <Link to="/dashboard" className="dnav-btn dnav-btn--primary">My Space</Link>
            ) : (
              <>
                <Link to="/login"  className="dnav-btn dnav-btn--ghost">Log in</Link>
                <Link to="/signup" className="dnav-btn dnav-btn--primary">Sign up</Link>
              </>
            )}
          </div>

          {/* Mobile: My Space pill (always visible) */}
          {isAuthenticated && (
            <Link to="/dashboard" className="dnav-mobile-myspace">My Space</Link>
          )}

          {/* Hamburger */}
          <button
            className={`dnav-hamburger${open ? ' is-open' : ''}`}
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
            aria-expanded={open}
          >
            <span /><span /><span />
          </button>
        </div>

        {/* Mobile drawer */}
        <div
          className={`dnav-drawer${open ? ' is-open' : ''}`}
          ref={drawerRef}
          aria-hidden={!open}
        >
          <ul className="dnav-drawer-links">
            {NAV_LINKS.map(({ to, label }, i) => (
              <li key={to} style={{ '--i': i }}>
                <NavLink
                  to={to}
                  className={({ isActive }) => `dnav-drawer-link${isActive ? ' active' : ''}`}
                >
                  {label}
                </NavLink>
              </li>
            ))}
          </ul>

          <div className="dnav-drawer-auth">
            {isAuthenticated ? (
              <Link to="/dashboard" className="dnav-btn dnav-btn--primary dnav-btn--full">My Space</Link>
            ) : (
              <>
                <Link to="/login"  className="dnav-btn dnav-btn--ghost  dnav-btn--full">Log in</Link>
                <Link to="/signup" className="dnav-btn dnav-btn--primary dnav-btn--full">Sign up</Link>
              </>
            )}
          </div>
        </div>
      </nav>

      {/* Backdrop */}
      {open && <div className="dnav-backdrop" onClick={() => setOpen(false)} aria-hidden="true" />}

      <div className="outlet">
        <Outlet />
      </div>
      <Footer />
    </>
  );
};

export default Navbar;
